import { Button, Divider, Flex, Space, Typography } from 'antd'
import { useNavigate, useParams } from 'react-router-dom'

import { UserService } from '@services/UserService'
import { useConfirmation } from '@store/confirmation'
import { useNotifications } from '@store/notifications'

import type { User } from '../../../../../types'

export const DangerZoneTab = ({ user, refetch }: { user: User; refetch: () => Promise<void> }) => {
    const { showNotification } = useNotifications()
    const confirm = useConfirmation()
    const navigate = useNavigate()
    const { userId } = useParams()

    const onDisableUser = async () => {
        if (!userId) {
            return
        }
        if (
            await confirm({
                title: 'Are you sure you want to disable this user?',
                confirmText: 'Disable'
            })
        ) {
            try {
                await UserService.disable(userId)

                showNotification({
                    title: 'User has been disabled'
                })

                refetch()
            } catch (err) {
                showNotification({
                    title: 'User could not be disabled',
                    type: 'error'
                })
            }
        }
    }

    const onDeleteUser = async () => {
        if (!userId) {
            return
        }
        if (
            await confirm({
                title: 'Are you sure you want to delete this user?',
                confirmText: 'Delete'
            })
        ) {
            try {
                await UserService.remove(userId)

                showNotification({
                    title: 'User has been deleted'
                })

                navigate('/users')
            } catch (err) {
                showNotification({
                    title: 'User could not be deleted',
                    type: 'error'
                })
            }
        }
    }

    return (
        <>
            {/* <Typography.Text>Please remove all users from the school prior to deleting</Typography.Text> */}
            <Space direction="vertical">
                <Flex>
                    <Button danger onClick={onDisableUser} disabled={user.status === 'DISABLED'}>
                        Disable User
                    </Button>
                </Flex>
                <Divider />
                <Typography.Text>User must be disabled prior to deleting</Typography.Text>
                <Flex>
                    <Button type="primary" danger onClick={onDeleteUser} disabled={user.status !== 'DISABLED'}>
                        Delete User
                    </Button>
                </Flex>
            </Space>
        </>
    )
}
